// Native
import { Badge, Separator, Table } from "@chakra-ui/react"
import moment from "moment"
import { useState } from "react"
import { useNavigate } from "react-router"

// Custom
import { Form, UI } from "components"
import { Styles } from "config"
import useOrders from "hooks/useOrders"

export default function List(){

    const [ page, setPage ] = useState(1)
    const [ term, setTerm ] = useState('')
    const orders = useOrders(page, term, 1)

    const columns = [{ children: 'Código' }, { children: 'Status' }, { children: 'Núcleo' }, { children: 'Total', textAlign: 'right' }, { children: 'Pontos', textAlign: 'right' }, { children: 'Data do pedido', textAlign: 'right' }]

    return(
    <>
    <UI.Searchable placeholder="Procurar pelo código do pedido..." value={term} onChange={setTerm} />
    <Separator my={4} />
    <UI.Table interactive label="Histórico de pedidos" loading={orders.isFetching} data={orders.data?.data} Row={Row} columns={columns} meta={orders.data?.meta} onPageChange={e => setPage(e.page)} />
    </>
    )
}

const Row = ({ data }) => {

    const navigate = useNavigate()
    const statusStyle = Styles.orderStatus(data.status)

    return(
    <Table.Row cursor="pointer" key={data.id} onClick={() => navigate(`/pedidos/${data.cod}`)}>
        <Table.Cell>{data.cod}</Table.Cell>
        <Table.Cell><Badge colorPalette={statusStyle.colorPalette}><UI.Icon name={statusStyle.icon} /> {statusStyle.label}</Badge></Table.Cell>
        <Table.Cell fontSize="xs"><Badge size="sm">{data.distributor_from?.name}</Badge></Table.Cell>
        <Table.Cell textAlign="right" fontWeight="bold"><UI.Number.Amount value={data.total_amount} /></Table.Cell>
        <Table.Cell textAlign="right"><Badge>{data.points/100} pontos</Badge></Table.Cell>
        <Table.Cell textAlign="right" color="GrayText">{moment(data.created_at).format('LLL')}</Table.Cell>
    </Table.Row>
    )
}